"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetUser = void 0;
const react_1 = require("react");
const LwtApp_1 = require("../LwtApp");
const i18n_util_1 = require("../@common/util/i18n-util");
const use_auth_strategy_factory_1 = require("../@internal/hooks/use-auth-strategy-factory");
const use_query_1 = __importDefault(require("../@common/hooks/network/use-query"));
const config_1 = __importDefault(require("../@internal/config"));
const { defaultA11ySettings } = config_1.default;
const useGetUser = ({ options, fallbackData = undefined }) => {
    const [store, { setStore }] = (0, LwtApp_1.useLwtStore)();
    const { getUser } = (0, use_auth_strategy_factory_1.useAuthStrategyFactory)();
    const { loading, data /*, err */ } = (0, use_query_1.default)(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        return (_c = (_b = (yield (getUser === null || getUser === void 0 ? void 0 : getUser({
            params: { include: (_a = options === null || options === void 0 ? void 0 : options.getUserParams) !== null && _a !== void 0 ? _a : [] }
        })))) === null || _b === void 0 ? void 0 : _b.data) !== null && _c !== void 0 ? _c : fallbackData;
    }), {
        shouldRun: true,
        onError: err => err // TODO
    });
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (!data)
            return;
        const shouldPersist = param => { var _a; return (_a = options === null || options === void 0 ? void 0 : options.getUserParams) === null || _a === void 0 ? void 0 : _a.includes(param); };
        const getSettings = data => {
            var _a;
            const isSettingsAnArray = data.settings instanceof Array;
            const accessibilitySetting = isSettingsAnArray
                ? (_a = data === null || data === void 0 ? void 0 : data.settings) === null || _a === void 0 ? void 0 : _a.find(setting => (setting === null || setting === void 0 ? void 0 : setting.setting) === 'accessibility')
                : null;
            return Object.assign({ accessibility: (accessibilitySetting === null || accessibilitySetting === void 0 ? void 0 : accessibilitySetting.value) || defaultA11ySettings }, data.settings);
        };
        // if there is a 'getUser' function, use it; else use injected data
        try {
            const { featureToggles } = data, user = __rest(data, ["featureToggles"]);
            const locale = (_a = data.settings.locale) !== null && _a !== void 0 ? _a : data === null || data === void 0 ? void 0 : data.locale;
            const settings = getSettings(data);
            // this is needed for old user which have no previous videoNarrationSettings obj on settings
            if (!((_b = settings.accessibility) === null || _b === void 0 ? void 0 : _b.videoNarrationSettings)) {
                settings.accessibility.videoNarrationSettings = defaultA11ySettings.videoNarrationSettings;
            }
            setStore(Object.assign(Object.assign({ user }, (shouldPersist('settings') && settings && { settings })), (shouldPersist('featureToggles') && featureToggles && { featureToggles })));
            if (locale)
                (0, i18n_util_1.setLocale)(locale);
        }
        catch (err) {
            // TODO: handle error
        }
    }, [data]);
    return { user: store.user, loading };
};
exports.useGetUser = useGetUser;
